module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("CHAPTER 3")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "chapsub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Broken Bones")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of only three bars in Dutch Harbor, the Broken Bones was aptly named, as it all too often delivered on its sign’s promise. Though the town was a famous tourist destination as the result of documentaries and reality TV shows filming the frontier way of life, it was the only establishment avoided by tourists, as well as producers and cameramen from the Discovery Channel. It was renowned for three things—violent fistfights, drinking escapades that would make any practicing alcoholic proud, and a particular distaste for outsiders. An unofficial policy by the police allowed the mayhem to continue, except in the most extreme cases. The last visit by the chief had followed a fight between two deckhands that had escalated wildly to the point that one of the men broke the other’s jaw with a fish bat, only to have his right hand smashed by a crab hammer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only silver lining was the bar’s location on the harbor side of Gilman Road, across the street from the dental clinic, which profited from the steady influx of patients. A percentage of those charges went right back into the Broken Bones’s coffer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Chief Phoenix had delivered Logan and John to the Grand Aleutian Hotel shortly after Logan’s arrival. He’d offered to drive them around the island. They’d declined, instead choosing to rent a pickup ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("truck from the hotel, which offered the service for its guests since the island wasn’t large enough for a car rental agency. They’d also been provided directions to the island’s three bars. The Broken Bones was first on their list.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan and John walked through the double set of glass doors and into a different era. As the door shut behind them, all conversation stopped. Logan thought, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Just like a scene out of the Wild West. This is going to be fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in the middle of the afternoon, the number of patrons was surprisingly large. They occupied at least half of the establishment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main bar to the left of the entrance ran the entire length of the space. The opposite wall was solid glass from floor to ceiling. The central floor had several high tables with bar stools randomly positioned, and a set of stairs at each end connected to a lower level with several hardwood booths scattered along the picture window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond the glass was a gorgeous view of Dutch Harbor’s largest bay. Two main waterways served as entrances to the harbor, and fishing boats of all sizes were moored to pylons and piers along the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan and John ignored the silence and maneuvered their way through the tables and astonished stares of several patrons. Logan’s peripheral vision picked up a man in his sixties with his jaw agape at the sight of the two interlopers. Logan nodded at him and kept moving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They reached the bar, to be greeted by a small, wiry man with thinning white hair that hung from the back of his head to his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen, guys, it’s obvious you’re not from around here. So let me be blunt,” the bartender said. “This place is not for "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Logan,” John said, “do you mind if I handle this situation and educate our new friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Be my guest,” Logan said, and motioned for John to continue. He stood back and crossed his arms over his chest, smiling at the bartender.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The bartender grew uneasy. Something in the man’s green eyes set his nerves on edge. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("This is not going to go as I thought.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir, what’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man answered, “Will, but everyone calls me Willy, like the killer whale.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s great, Willy. My name’s John, and this here is my partner, Logan. And believe it or not, we’re with the FBI investigating a possible threat to national security, as crazy as that sounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Willy’s eyes grew wide. “You’ve got to be kidding me. Nothing goes on up here except that TV show and tourists who want to see where it’s filmed. Are you talking about some kind of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("terrorist attack")]), _vm._v("?” he asked incredulously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Willy, I can’t really tell you much more than that, but what I really need to know is if you or any of your guests here have seen anything unusual since the storm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan watched John cajole the bartender as he observed the patrons behind them in a large mirror behind the bar. At a table near the middle of the floor, two large men quietly stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Great . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean by ‘unusual’?” Willy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two men slipped through the tables, covering the distance quickly. They were almost directly behind Logan and John.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By unusual, I mean any—” John continued before Logan cut him off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have company,” Logan said quietly, nodding at the mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Always has to be one or two, doesn’t it?” John said, a wicked grin on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With us? Of course it does,” Logan replied, and both men turned around.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("John opened his arms wide, welcoming the newcomers, who now stood in front of them. The man in front of John was close to six foot four inches tall and weighed more than 240 pounds, an unhealthy combination of fat and muscle. His black hair was pulled back in a ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("ponytail, and he wore a beard that reached a burly chest covered by a black Harley-Davidson T-shirt.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The second man was Logan’s height and more physically fit than his partner. His brown hair was slicked back in homage to the 1950s, and he was clean-shaven. It was also obvious he’d been drinking for several hours. He looked like a cliché, an angry man looking for any excuse to fight for a temporary distraction from his empty and frustrated life. Logan had felt that way once, before sobriety had finally clicked and slowly filled that lonely void in his soul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gentlemen, I’m going to make this as simple as possible for you both,” John explained. “We’re with the FBI, and we’re trying to have a private conversation with this fine, upstanding citizen. So, do you really want to do this right now? I strongly advise against it; however, if that’s what you really want, then I guess I can use the sparring practice. It’s your call.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John stared up at the bearded man, all emotion drained from his expression. It was a hardened look Logan knew well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The giant of a man turned his head to his left but kept his eyes on John. “You believe the bullshit coming out of this guy’s mouth?” He looked John squarely in the eyes and leaned down into his face. He growled, “You’re going to regret walking through those doors. As Willy said, we don’t take kindly to outsiders, especially tiny specimens like you.” The last words were spat with contempt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was all John needed. The time for talking had passed. At 180 pounds and five feet ten inches, he was incredibly fast. He and Logan acted simultaneously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With blinding speed, John reached out and grabbed the big man’s beard with his left hand. He yanked forward viciously and pivoted on his left foot as he lowered his center of gravity. He completed the turn and pulled even harder. The momentum he created sent the man crashing headlong into the front of the bar.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("A loud "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("crunch")]), _vm._v(" stunned the other patrons as the man’s nose was ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("crushed by the rounded corner of the marble countertop. Blood splashed onto the bar and down his shirt. He seemed to bounce backward, and as he did so, John stuck out his left leg, almost casually. The man tripped over John’s ankle and fell to the floor. The impact knocked the wind out of him, and he lay on the ground, dazed. He stared at the ceiling as blood continued to flow from his shattered nose.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan’s actions were less graceful but no less effective. He delivered two quick jabs squarely to his opponent’s face and split both upper and lower lips. The man reeled in surprise and raised his hands in self-defense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan used the sudden distance between them to deliver a spinning back kick that landed on the man’s sternum with tremendous force. The kick launched the man rearward, and he flew into a table, which caught him squarely in the middle of the back. He seemed to scream in pain as his arms flailed, but there was no air left in his lungs to make a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan was mildly amused to see the guy stagger forward once more, somehow still on his feet. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oh well . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan stepped forward and delivered a powerful punch to the man’s midsection. There was an audible gasp from around the room as the second aggressive local fell to the floor, facedown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silence engulfed the Broken Bones, the patrons shell-shocked at the vicious display of precision violence. Two of their own had just been dispatched with what seemed like completely effortless action. They stared at the intruders. John Quick didn’t wait for them to recover before he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As I tried to tell these two gentlemen, we’re with the FBI looking for anything unusual. A new crew none of you have ever seen before, a new boat in town, anything at all. . . . Now I don’t want to have to repeat what just happened, and if you want us to get out of here quickly, someone’s going to have to tell us something.” John looked around the room, making eye contact with each man.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“Why do you think we came here first? We know who you are, what you’re about. Hell, when I’m not doing this, I live in Montana in the middle of goddamn nowhere so I can hunt and fish in seclusion. I respect your lifestyle.” John could feel a change in the room, a softening of the hostile atmosphere. He continued.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We know that you’d know if somebody new was on the island, someone not from around here.” He paused to let the words sink in to their dazed psyches. “Believe it or not, guys, we’re on the same side. So I’m going to ask one more time—no bullshit—does anyone know anything that can help us out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The assembled men looked at each other. Logan saw comprehension, fear, and respect all at once. Logan and John had made their point and proven their mettle and determination.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was why he’d insisted to the police chief that they do this alone. He knew that with men like these, there was often only one way to gain their trust. Dutch Harbor men were hard. They valued toughness and resilience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A rumble of approval reverberated through the bar, even as the two locals lay on the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a few moments, a man in his late twenties sitting in a booth along the window quietly said, “The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Arctic Glide")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logan walked over to the railing at the edge of the main floor and looked down at the man. “I’m sorry. I could barely hear you back there. What did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man gained confidence at the sound of his own voice and repeated, “The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Arctic Glide")]), _vm._v(". I think that’s what you’re looking for.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0